var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Log, LogCategory } from '@augloop/logging';
var BufferingSequencer = /** @class */ (function () {
    function BufferingSequencer(bufferingTimeMs, rejectOutdatedSequenceNumbers) {
        if (bufferingTimeMs === void 0) { bufferingTimeMs = 500; }
        if (rejectOutdatedSequenceNumbers === void 0) { rejectOutdatedSequenceNumbers = false; }
        this.prevSeq = -1;
        this.bufferingTimeMs = bufferingTimeMs;
        this.rejectOutdatedSequenceNumbers = rejectOutdatedSequenceNumbers;
    }
    BufferingSequencer.prototype.sequence = function (seq) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (seq < _this.prevSeq) {
                // sequence was reset or significantly delayed annotation arrived
                if (_this.rejectOutdatedSequenceNumbers) {
                    var error = new Error("BufferingSequencer: Item out of order. Expecting seqId > " + _this.prevSeq + ". Actual seqId " + seq);
                    error.name = BufferingSequencer.Rejected;
                    reject(error);
                    return;
                }
                else {
                    _this.prevSeq = -1;
                }
            }
            if (seq != _this.prevSeq + 1) {
                Log.warn(0x20592241 /* tag_6wsjb */, LogCategory.WorkflowDefault, "BufferingSequencer: got out of order sequence number. Got " + seq + ", expected " + (_this.prevSeq + 1));
            }
            var item = { seq: seq, resolve: resolve };
            _this.insertItem(item);
            _this.runInOrder(item, true, false);
        });
    };
    BufferingSequencer.prototype.insertItem = function (item) {
        if (!this.firstQueueItem) {
            this.firstQueueItem = item;
            this.lastQueueItem = item;
            return;
        }
        var currentItem = this.lastQueueItem;
        var prevItem = null;
        do {
            if (item.seq > currentItem.seq) {
                item.prev = currentItem;
                currentItem.next = item;
                if (prevItem) {
                    prevItem.prev = item;
                }
                else {
                    this.lastQueueItem = item;
                }
                return;
            }
            prevItem = currentItem;
            currentItem = currentItem.prev;
        } while (currentItem);
        if (prevItem) {
            prevItem.prev = item;
        }
        item.next = prevItem;
        this.firstQueueItem = item;
    };
    BufferingSequencer.prototype.runInOrder = function (currentItem, scheduleDelayedProcessing, ignoreGapsForPreceedingElements) {
        var _this = this;
        var prevSeq = this.prevSeq;
        var currentItemResolved = false;
        var itemsToResolve = [];
        while (this.firstQueueItem) {
            var item = this.firstQueueItem;
            if (prevSeq + 1 != item.seq && (!ignoreGapsForPreceedingElements || item.seq > currentItem.seq)) {
                break;
            }
            prevSeq = item.seq;
            if (item.timeout) {
                clearTimeout(item.timeout);
            }
            itemsToResolve.push(item);
            if (currentItem == item) {
                currentItemResolved = true;
            }
            this.firstQueueItem = this.firstQueueItem.next;
            if (this.firstQueueItem) {
                this.firstQueueItem.prev = null;
            }
        }
        if (itemsToResolve.length > 0) {
            // setTimeout is needed here to fix an issue with incorrect order of promises continuations exectuion
            setTimeout(function () {
                var e_1, _a;
                try {
                    for (var itemsToResolve_1 = __values(itemsToResolve), itemsToResolve_1_1 = itemsToResolve_1.next(); !itemsToResolve_1_1.done; itemsToResolve_1_1 = itemsToResolve_1.next()) {
                        var item = itemsToResolve_1_1.value;
                        item.resolve(item.seq);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (itemsToResolve_1_1 && !itemsToResolve_1_1.done && (_a = itemsToResolve_1.return)) _a.call(itemsToResolve_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }, 0);
        }
        this.prevSeq = prevSeq;
        if (!currentItemResolved && scheduleDelayedProcessing) {
            currentItem.timeout = setTimeout(function () { _this.runInOrder(currentItem, false, true); }, this.bufferingTimeMs);
        }
    };
    BufferingSequencer.Rejected = 'SequenceItemRejected';
    return BufferingSequencer;
}());
export { BufferingSequencer };
//# sourceMappingURL=buffering-sequencer.js.map